import axios from 'axios'
import { camelCaseKeys, snakeCaseKeys } from '@/util'
import { setError } from './errorParser'

const _axios = axios.create({
  baseURL: `${process.env.common.defaultApi.host}/api`,
})

_axios.interceptors.request.use(
  (config) => {
    // snakeCaseKeys 강제변환
    config.data = snakeCaseKeys(config.data)
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

_axios.interceptors.response.use(
  (resp) => {
    return Promise.resolve(camelCaseKeys(resp))
  },
  (error) => {
    const { response } = error
    const errorResponse = setError(response)
    return Promise.reject(camelCaseKeys(errorResponse))
  },
)

export default _axios
